import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm md:text-base">快速了解香蕉影视的使用方式和服务特点</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 pr-4">{item.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-foreground-600 text-sm leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}